import { render, staticRenderFns } from "./AgreeTerm.vue?vue&type=template&id=3bd3a3d4&scoped=true"
import script from "./AgreeTerm.vue?vue&type=script&lang=js"
export * from "./AgreeTerm.vue?vue&type=script&lang=js"
import style0 from "./AgreeTerm.vue?vue&type=style&index=0&id=3bd3a3d4&prod&scoped=true&lang=scss"
import style1 from "./AgreeTerm.vue?vue&type=style&index=1&id=3bd3a3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd3a3d4",
  null
  
)

export default component.exports